export const QA_NAME_VIEWING_PROFILE_DOCUMENTS_RETRY = 'viewingDocumentsRetry'

export const QA_NAME_VIEWING_PROFILE_DOCUMENTS_TABLE = 'viewingDocuments'

export const QA_NAME_VIEWING_PROFILE_DOCUMENTS_UPLOAD = 'viewingDocumentsUpload'

export const VIEWING_DOCUMENT_UPLOAD_ACTION_NAME = 'uploadViewingDocument'

export const VIEWING_PROFILE_DOCUMENTS_SKELETON_ROWS = 3

export const VIEWING_DOCUMENTS_PAGE_SIZE = 20

export const ViewingDocumentColumnName = {
  Name: 'name',
  Size: 'size_bytes',
  Uploaded: 'uploaded_at',
  UploadedBy: 'uploaded_by',
}

export const VIEWING_DOCUMENT_COLUMNS_CONFIG = {
  [ViewingDocumentColumnName.Name]: {
    index: 0,
    name: ViewingDocumentColumnName.Name,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsNameColumnKey',
    visible: true,
    width: 300,
  },
  [ViewingDocumentColumnName.Size]: {
    index: 1,
    name: ViewingDocumentColumnName.Size,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsSizeColumnKey',
    visible: true,
    width: 110,
  },
  [ViewingDocumentColumnName.Uploaded]: {
    index: 2,
    name: ViewingDocumentColumnName.Uploaded,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedColumnKey',
    visible: true,
    width: 180,
  },
  [ViewingDocumentColumnName.UploadedBy]: {
    index: 3,
    name: ViewingDocumentColumnName.UploadedBy,
    ordering_field: null,
    title: 'RentalPortal.ListingProfileDocumentsUploadedByColumnKey',
    visible: true,
    width: 240,
  },
}
